export enum FormName {
  CreateRun = "CreateRun",
  CreateRunTask = "CreateRunTask",
  CreateRunTemplate = "CreateRunTemplate",
  CreateRunTemplateTask = "CreateRunTemplateTask",
  CreateTicket = "CreateTicket",
}
